"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var style = _interopRequireWildcard(require("./style"));
var _ScreenClassResolver = _interopRequireDefault(require("../../context/ScreenClassResolver"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Hidden = _ref => {
  let {
    children,
    xs = false,
    sm = false,
    md = false,
    lg = false,
    xl = false,
    xxl = false,
    xxxl = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ScreenClassResolver.default, null, screenClass => style.hidden({
    screenClass,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    xxxl
  }) ? null : children);
};
Hidden.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Hide on extra small devices
   */
  xs: _propTypes.default.bool,
  /**
   * Hide on small devices
   */
  sm: _propTypes.default.bool,
  /**
   * Hide on medium devices
   */
  md: _propTypes.default.bool,
  /**
   * Hide on large devices
   */
  lg: _propTypes.default.bool,
  /**
   * Hide on xlarge devices
   */
  xl: _propTypes.default.bool,
  /**
   * Hide on xxlarge devices
   */
  xxl: _propTypes.default.bool,
  /**
   * Hide on xxxlarge devices
   */
  xxxl: _propTypes.default.bool
};
var _default = exports.default = Hidden;